import { request } from "./http";

export interface PlanOut {
  code: string;
  name: string;
  seats_label: string;
  max_users: number | null;
  tier: string;
  monthly_price_minor: number;
  yearly_price_minor: number;
  purchasable: boolean;
  description: string;
}

export interface PublicPlans {
  currency: string;
  periods: string[];
  plans: PlanOut[];
}

export interface BillingOrderOut {
  id: string;
  created_at: string | null;
  plan_code: string;
  period: string;
  amount_minor: number;
  currency: string;
  status: string;
  paid_at: string | null;
  valid_until: string | null;
}

export interface BillingState {
  configured: boolean;
  currency: string;
  plan_code: string | null;
  plan_name: string | null;
  tier: string;
  expires_at: string | null;
  days_left: number | null;
  seats_limit: number | null;
  seats_active: number;
}

export interface MyBilling extends BillingState {
  orders: BillingOrderOut[];
}

export interface CheckoutSession {
  order_id: string;
  razorpay_order_id: string;
  key_id: string;
  amount_minor: number;
  currency: string;
  plan_code: string;
  period: string;
  name: string;
  description: string;
}

export interface RevenueSummary {
  currency: string;
  total_paid_minor: number;
  orders_paid: number;
  orders: {
    id: string;
    tenant: string;
    plan_code: string;
    period: string;
    amount_minor: number;
    currency: string;
    paid_at: string | null;
  }[];
}

export function publicPlans(): Promise<PublicPlans> {
  return request("/billing/plans", { anonymous: true });
}

export function myBilling(): Promise<MyBilling> {
  return request("/billing/");
}

export function createCheckout(planCode: string, period: string): Promise<CheckoutSession> {
  return request("/billing/checkout", {
    method: "POST",
    body: { plan_code: planCode, period },
  });
}

export function verifyPayment(
  orderId: string,
  paymentId: string,
  signature: string,
): Promise<MyBilling & { order: BillingOrderOut }> {
  return request("/billing/verify", {
    method: "POST",
    body: {
      order_id: orderId,
      razorpay_payment_id: paymentId,
      razorpay_signature: signature,
    },
  });
}

export function revenueSummary(): Promise<RevenueSummary> {
  return request("/billing/revenue");
}
